import React, { useEffect } from 'react';
import { observer } from 'mobx-react-lite';
import { useParams } from '@thd-olt-component-react/router';
import { ErrorBoundary } from '@thd-olt-component-react/error-boundary';
import { useStore } from '../../../store/index';
import PageHeader from '../../../components/common/PageHeader/PageHeader';
import { TabNavigation } from '../../../components/JobPostings/TabNavigation/TabNavigation';
import { JobPostingProvider } from '../../../contexts/JobPostingContext';
import { JobPostingPageHeader } from '../../../components/JobPostings/JobPostingPageHeader/JobPostingPageHeader';
import CompleteJobPostingDialog from '../../../components/MyDashboard/JobPostingComponents/CompleteJobPostingDialog';
import ReopenJobPostingDialog from '../../../components/MyDashboard/JobPostingComponents/ReopenJobPostingDialog';
import DeleteJobPostingDialog from '../../../components/MyDashboard/JobPostingComponents/DeleteJobPostingDialog';
import PublishJobPostingDialog from '../../../components/MyDashboard/JobPostingComponents/PublishJobPostingDialog';
import CancelJobPostingDialog from '../../../components/MyDashboard/JobPostingComponents/CancelJobPostingDialog';
import { pageLoadEvents } from '../../../utils/analytics';
import { HOME_PAGE_PATH } from '../../../utils/constants';

const _JobPostingPage = () => {

  const {
    jobPostingStore: { getJobPosting, activeJobPosting },
    authStore: {
      authorized,
      authInProgress
    }
  } = useStore();
  const { jobPostingId } = useParams();

  useEffect(() => {
    if (!authInProgress && !authorized) {
      window.location.replace(`${HOME_PAGE_PATH}`);
    } else {
      pageLoadEvents.jobPostingDetailsPage();
      getJobPosting(jobPostingId);
    }
  }, []);

  return (
    <ErrorBoundary name="job-posting-page">
      <PageHeader>Path to Pro Network</PageHeader>
      <ErrorBoundary name="job-posting-provider">
        <JobPostingProvider>
          <ErrorBoundary name="job-posting-page-header">
            <JobPostingPageHeader />
          </ErrorBoundary>
          <ErrorBoundary name="tab-navigation">
            <TabNavigation jobPostingTitle={activeJobPosting.title} />
          </ErrorBoundary>
          <ErrorBoundary name="cancel-job-posting-dialog">
            <CancelJobPostingDialog jobPostingPage />
          </ErrorBoundary>
          <ErrorBoundary name="complete-job-posting-dialog">
            <CompleteJobPostingDialog jobPostingPage />
          </ErrorBoundary>
          <ErrorBoundary name="reopen-job-posting-dialog">
            <ReopenJobPostingDialog jobPostingPage />
          </ErrorBoundary>
          <ErrorBoundary name="publish-job-posting-dialog">
            <PublishJobPostingDialog />
          </ErrorBoundary>
          <ErrorBoundary name="delete-job-posting-dialog">
            <DeleteJobPostingDialog />
          </ErrorBoundary>
        </JobPostingProvider>
      </ErrorBoundary>
    </ErrorBoundary>
  );
};

export const JobPostingPage = observer(_JobPostingPage);
